import { HTime, HTimeFormat } from "../lib/HDateTime";
export function StartListCategoryHeader(props) {
    return (
        <div className="grid grid-cols-12 border-b-2 p-2">
            <div className="col-span-2 ">
                Start
            </div>
            <div className="col-span-5">
                Name
            </div>
            <div className="col-span-5">
                Club
            </div>
        </div>
    )
}

export function StartListCategoryRow(props) {
    return (
        <div className="grid grid-cols-12 border-b-2 p-2">
            <div className="col-span-2 ">
                {HTime.Parse(props.person.StartTime).ToString(HTimeFormat.HMS)}
            </div>
            <div className="col-span-5">
                {props.person.Name}
            </div>
            <div className="col-span-5">
                {props.person.Club}
            </div>
        </div>
    )
}
